import { MainAreaPropsType } from "../../types/app.type";
import { MainAreaWrapper } from "./styled";

export const MainArea: React.FC<MainAreaPropsType> = ({ children }) => {
    return (
        <MainAreaWrapper>
            {children}
        </MainAreaWrapper>
    )
}